import { GiftToneDto } from '../../../dto/gifttone/gifttonedto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface GiftToneRequest extends APIRequest
{
    getGiftToneRequest(): GiftToneDto;
}

export class GiftToneRequestImpl extends APIRequestDtoImpl implements GiftToneRequest
{
    constructor(private giftToneData: GiftToneDto)
    {
        super();
    }

    getGiftToneRequest(): GiftToneDto
    {
        return this.giftToneData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/gifttune/gifttonerequest.tsx